import { NumberFormat } from '@instinet-analytics/core-lib';
import isNil from 'lodash/isNil';

export function applyTickSize(
    numberFormat: NumberFormat,
    tickSize: number | null | undefined,
    value: number | null | undefined
): string {
    if (value === undefined || value === null) {
        return '';
    }
    return tickSizeFormatFn(numberFormat, tickSize)(value);
}

export function tickSizeFormatFn(
    numberFormat: NumberFormat,
    tickSize: number | null | undefined
): (d: number) => string {
    if (tickSize === undefined || tickSize === null) {
        return numberFormat.n2.bind(numberFormat);
    }
    if (tickSize >= 1) {
        return numberFormat.n0.bind(numberFormat);
    }
    if (tickSize >= 0.01) {
        return numberFormat.n2.bind(numberFormat);
    }
    if (tickSize >= 0.001) {
        return numberFormat.n3.bind(numberFormat);
    }
    return numberFormat.n4.bind(numberFormat);
}

export function tickSizeToPrecision(tickSize: number | null | undefined) {
    if (tickSize === undefined || tickSize === null) {
        return 2;
    }
    if (tickSize >= 1) {
        return 0;
    }
    if (tickSize >= 0.01) {
        return 2;
    }
    if (tickSize >= 0.001) {
        return 3;
    }
    return 4.1; // Forces n4 rather than n2to4
}

export function applyTickSizeWithComparison(
    numberFormat: NumberFormat,
    tickSize: number | null | undefined,
    value: number | null | undefined,
    comparisonValue: number | null | undefined
): string {
    if (value === undefined || value === null) {
        return '';
    }

    const formatted = applyTickSize(numberFormat, tickSize, value);
    if (formatted === '') {
        return formatted;
    }
    if (!formatted) {
        throw new Error('hey');
    }

    const formattedValue = parseFloat(formatted);

    if (isNil(comparisonValue)) {
        return formatted;
    }

    if (formatted.indexOf('.') === -1) {
        return formatted;
    }

    if (Math.floor(formattedValue) === Math.floor(comparisonValue)) {
        return formatted.slice(formatted.indexOf('.'));
    }

    return formatted;
}
